import { Component, AfterViewInit } from '@angular/core';
import { HttpService,HttpCall } from '../http-service.service';


@Component({
  selector: 'app-veicoli',
  templateUrl: './veicoli.component.html',
  styleUrls: ['./veicoli.component.scss']
})
export class VeicoliComponent implements AfterViewInit {
  loading:boolean = true;
  dati:any[];

  mesi:string[] = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre']
  giorni:string[] = ['Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato','Domenica']

  constructor(private httpService:HttpService) {
  }


  ngAfterViewInit() {
    this.refresh();
  }

  refresh() {
    this.loading=true;
    let call:HttpCall = {url:"enduser/gruppi"}
    this.httpService.GetJSONContent<any>(call).subscribe(response => {
      this.dati = response.body;
    },(e)=>{this.loading=false},()=>{this.loading=false});
  }

}
